import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'
import type { CaseSearchItem } from '@/lib/queries/business/types'

import { type ReqRegistserCaseMutation } from './types'

export const createCaseMutation = {
  mutationFn: (payload: ReqRegistserCaseMutation): Promise<CaseSearchItem> =>
    w.post(payload, API_ENDPOINTS.business.v2.case.register.index).json(),
}
